
import headerSearch from  '../components/header-search'
import { Toast } from 'vant'
import instance from '../assets/js/instance'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'


export default {
data () {
return {
index: 0,
baseUrl: process.env.BASE_URL,
pull: false,
tabList: [],
tabLength: 2
}
},
computed: {
options () {
return this.$t('type')
},
path () {
return this.$store.getters.getPath
},

cMenu() {
return this.$t("cMenu");
},

isPhone() {
return this.$store.getters.getIsPhone;
}
},
watch: {
index (val) {
let arr = this.tabList[val].list
if (arr.length === 0) {
this.getList()
}
this.pull = false
}
},
components: {
headerSearch,
Tab,
TabItem,
Swiper,
SwiperItem
},
methods: {
refresh (item) {
this.$nextTick(() => {
item.list = []
this.getList()
})
},

getList () {
let item = this.tabList[this.index]
if (item.list.length === 0) {
this.showToast()
instance(`/api/goods/getGoods?p=${item.page}&cat_id=${item.id}`).then(res => {
let data = res.data
if (data.code === 0) {
this.checkoutList(data.data.list)
}
}).catch(e => {
console.log(e)
})
}
},

checkoutList (data) {
let arr = [... this.tabList]
arr[this.index].list = arr[this.index].list.concat(data)
this.tabList = arr
this.clearToast()
this.pull = false
},


showToast () {
Toast.loading({
duration: 0,
mask: true,
message: this.options.loading
})
},

clearToast () {
Toast.clear()
},

go (id) {
this.$router.push(`${this.path}/detail?id=${id}`)
},

getType () {
this.showToast()
instance('/api/goods/getCats').then(res => {
let data = res.data
if (data.code === 0) {
this.checkoutType(data.data.list)
}
}).catch(e => {
console.log(e)
})
},

checkoutType (data) {
let arr = [... data]
arr = arr.map(item => {
item.pull = false
item.list = []
item.page = 1
return item
})
this.tabList = arr
if (this.tabList.length > 0) {
this.getList()
} else {
this.clearToast()
}
},

init () {
if (!instance.defaults.headers.language) {
return false
}
this.getType()
}
},
mounted () {
this.init()
window.subscribe.listen('languageChange', () => {
this.init()
})

},
destroyed() {

},
}
